import React, { Component } from "react";
import {
  Input,
  Label,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import { Button } from "reactstrap";

class OrgDetails extends Component {
  state = {
    activeTab: "1",
    AdvisorEmail: this.props.orgName.AdvisorEmail,
    AdvisorName: this.props.orgName.AdvisorName,
    AdvisorPhone: this.props.orgName.AdvisorPhone,
    AutoID: this.props.orgName.AutoID,
    ChapterName: this.props.orgName.ChapterName,
    Charter: this.props.orgName.Charter,
    Comments: this.props.orgName.Comments,
    Constitution: this.props.orgName.Constitution,
    Description: this.props.orgName.Description,
    Email: this.props.orgName.Email,
    FallRoster07: this.props.orgName.FallRoster07,
    FallRoster08: this.props.orgName.FallRoster08,
    FallRoster09: this.props.orgName.FallRoster09,
    Keywords: this.props.orgName.Keywords,
    KirkContract: this.props.orgName.KirkContract,
    Name: this.props.orgName.Name,
    Renewal07: this.props.orgName.Renewal07,
    Renewal0809: this.props.orgName.Renewal0809,
    Renewal0910: this.props.orgName.Renewal0910,
    RiskMgtDone: this.props.orgName.RiskMgtDone,
    RiskMgtEmail: this.props.orgName.RiskMgtEmail,
    RiskMgtName: this.props.orgName.RiskMgtName,
    RiskMgtPhone: this.props.orgName.RiskMgtPhone,
    Size: this.props.orgName.Size,
    SpringRoster08: this.props.orgName.SpringRoster08,
    SpringRoster09: this.props.orgName.SpringRoster09,
    SpringRoster10: this.props.orgName.SpringRoster10,
    Standing: this.props.orgName.Standing,
    StudentContact: this.props.orgName.StudentContact,
    StudentEmail: this.props.orgName.StudentEmail,
    StudentPhone: this.props.orgName.StudentPhone,
    Type: this.props.orgName.Type,
    FinancialManagerName: this.props.orgName.FinancialManagerName,
    FinancialManagerEmail: this.props.orgName.FinancialManagerEmail,
    FinancialManagerPhone: this.props.orgName.FinancialManagerPhone,
    RosterManagerName: this.props.orgName.RosterManagerName,
    RosterManagerEmail: this.props.orgName.RosterManagerEmail,
    RosterManagerPhone: this.props.orgName.RosterManagerPhone,
    URL: this.props.orgName.URL,
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSave = (Comments, AutoID) => {
    //headers
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    //Request body
    const body = JSON.stringify({ AutoID, Comments });

    axios.post("/api/orgs/id", body, config).then(() => {
      this.props.getNewOrgsUpdate();
      this.props.toggle();
    });
  };

  createInfoBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let infoBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = false;if (thisMonth+1 >= 8)

      if (this.props.advisor) {
        this.props.info.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = true;
          }
        });
      }

      infoBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {thisChecked ? (
              <b>
                <font color="green"> Yes</font>
              </b>
            ) : (
              <b>
                <font color="red"> No</font>
              </b>
            )}
          </p>
        </div>
      );
    }

    return infoBlock;
  };
  
  createAdvisorBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let advisorBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = false;

      if (this.props.advisor) {
        this.props.advisor.forEach((element) => {
          let thisLoopYear = element.year;
          console.log(this.props.advisor);
          if (thisLoopYear == i) {
            thisChecked = true;
          }
        });
      }

      advisorBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {thisChecked ? (
              <b>
                <font color="green"> Yes</font>
              </b>
            ) : (
              <b>
                <font color="red"> No</font>
              </b>
            )}
          </p>
        </div>
      );
    }

    return advisorBlock;
  };

  createRenewalBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let renewalBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = false;

      if (this.props.renewal) {
        this.props.renewal.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = true;
          }
        });
      }

      renewalBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {thisChecked ? (
              <b>
                <font color="green"> Yes</font>
              </b>
            ) : (
              <b>
                <font color="red"> No</font>
              </b>
            )}
          </p>
        </div>
      );
    }

    return renewalBlock;
  };

  createRosterBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentSemester = "";

    if (thisMonth+1 < 8) {
      currentSemester = "S";
    } else {
      currentSemester = "F";
    }

    let rosterBlock = [];

    for (let i = 2017; i <= thisYear; i++) {
      let thisSpringChecked = false;
      let thisFallChecked = false;
      let thisSpringCount = "";
      let thisFallCount = "";

      if (this.props.roster) {
        this.props.roster.forEach((element) => {
          let thisLoopYear = element.year;
          let thisCount = element.members;

          if (thisLoopYear == i + "S") {
            thisSpringChecked = true;
            thisSpringCount = thisCount;
          }

          if (thisLoopYear == i + "F") {
            thisFallChecked = true;
            thisFallCount = thisCount;
          }
        });
      }

      if (i >= 2017) {
        rosterBlock.push(
          <div key={i}>
            <div>
              <p>
                {"Spring " + i} :&nbsp;&nbsp;
                {thisSpringChecked ? (
                  <b>
                    <font color="green"> Yes &nbsp;&nbsp;</font>
                    <font> Number of Members : {thisSpringCount}</font>
                  </b>
                ) : (
                  <b>
                    <font color="red"> No</font>
                  </b>
                )}
              </p>
            </div>
            <div>
              <p>
                {"Fall " + i} :&nbsp;&nbsp;&nbsp;&nbsp;
                {thisFallChecked ? (
                  <b>
                    <font color="green"> &nbsp;Yes &nbsp;&nbsp;</font>
                    <font> Number of Members : {thisFallCount}</font>
                  </b>
                ) : (
                  <b>
                    <font color="red"> No</font>
                  </b>
                )}
              </p>
            </div>
          </div>
        );
      }
    }

    return rosterBlock;
  };

  createWorkshopBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let workshopBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = false;

      if (this.props.workshop) {
        this.props.workshop.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = true;
          }
        });
      }

      workshopBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {thisChecked ? (
              <b>
                <font color="green"> Yes</font>
              </b>
            ) : (
              <b>
                <font color="red"> No</font>
              </b>
            )}
          </p>
        </div>
      );
    }

    return workshopBlock;
  };

  createRiskMgtBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    let riskMgtBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = false;
      let thisChecked2 = false;

      if (this.props.riskmgt) {
        this.props.riskmgt.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = true;
          }
        });
      }

      if (this.props.riskmgt2) {
        this.props.riskmgt2.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked2 = true;
          }
        });
      }

      riskMgtBlock.push(
        <div key={i}>
          <div>
            <p>
              {"Spring " + i } :&nbsp;&nbsp;&nbsp;&nbsp;
              {thisChecked2 ? (
                <b>
                  <font color="green">Yes &nbsp;&nbsp;</font>
                </b>
              ) : (
                <b>
                  <font color="red"> No</font>
                </b>
              )}
            </p>
          </div>
          <div>
            <p>
              {"Fall " + i } :&nbsp;&nbsp;
              {thisChecked ? (
                <b>
                  <font color="green"> Yes &nbsp;&nbsp;</font>
                </b>
              ) : (
                <b>
                  <font color="red"> No</font>
                </b>
              )}
            </p>
          </div>
        </div>
      );
    }

    return riskMgtBlock;
  };

  createFinancialRiskBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentSemester = "";

    if (thisMonth+1 < 8) {
      currentSemester = "S";
    } else {
      currentSemester = "F";
    }

    let financialRiskBlock = [];

    for (let i = 2017; i <= thisYear; i++) {
      let thisSpringChecked = false;
      let thisFallChecked = false;

      if (this.props.roster) {
        this.props.financialRisk.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i + "S") {
            thisSpringChecked = true;
          }

          if (thisLoopYear == i + "F") {
            thisFallChecked = true;
          }
        });
      }

      if (i >= 2017) {
        financialRiskBlock.push(
          <div key={i}>
            <div>
              <p>
                {"Spring " + i} :&nbsp;&nbsp;
                {thisSpringChecked ? (
                  <b>
                    <font color="green"> Yes &nbsp;&nbsp;</font>
                  </b>
                ) : (
                  <b>
                    <font color="red"> No</font>
                  </b>
                )}
              </p>
            </div>
            <div>
              <p>
                {"Fall " + i} :&nbsp;&nbsp;&nbsp;&nbsp;
                {thisFallChecked ? (
                  <b>
                    <font color="green"> &nbsp;Yes &nbsp;&nbsp;</font>
                  </b>
                ) : (
                  <b>
                    <font color="red"> No</font>
                  </b>
                )}
              </p>
            </div>
          </div>
        );
      }
    }

    return financialRiskBlock;
  };

  render() {
    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "1" })}
              onClick={() => {
                this.toggle("1");
              }}>
              Basics
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "2" })}
              onClick={() => {
                this.toggle("2");
              }}>
              Contacts
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "3" })}
              onClick={() => {
                this.toggle("3");
              }}>
              Status
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "4" })}
              onClick={() => {
                this.toggle("4");
              }}>
              Recognition
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "5" })}
              onClick={() => {
                this.toggle("5");
              }}>
              Info
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "6" })}
              onClick={() => {
                this.toggle("6");
              }}>
              Rosters
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "7" })}
              onClick={() => {
                this.toggle("7");
              }}>
              Workshops
            </NavLink>
          </NavItem>
		  <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "8" })}
              onClick={() => {
                this.toggle("8");
              }}>
              Advisors
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "9" })}
              onClick={() => {
                this.toggle("9");
              }}>
              Description
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "10" })}
              onClick={() => {
                this.toggle("10");
              }}>
              Comments
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "11" })}
              onClick={() => {
                this.toggle("11");
              }}>
              Physical Risk 
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "12" })}
              onClick={() => {
                this.toggle("12");
              }}>
              Financial Risk 
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="6">
                <Label for="Name">Organization Name:</Label>
                <Input
                  type="text"
                  name="Name"
                  id="Name"
                  value={this.state.Name}
                  onChange={this.onChange}
                  readOnly
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Chapter">Chapter:</Label>
                <Input
                  type="text"
                  name="ChapterName"
                  id="ChapterName"
                  value={this.state.ChapterName}
                  onChange={this.onChange}
                  readOnly
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Type">Type:</Label>
                <Input
                  type="text"
                  name="Type"
                  id="Type"
                  value={this.state.Type}
                  onChange={this.onChange}
                  readOnly
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="URL">URL:</Label>
                <a href={this.state.URL}>
                  <Input
                    type="url"
                    name="URL"
                    id="URL"
                    value={this.state.URL}
                    onChange={this.onChange}
                    readOnly
                  />
                </a>
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Name">Organization Email:</Label>
                <a href={"mailto:" + this.state.Email}>
                  <Input
                    type="email"
                    name="Email"
                    id="Email"
                    value={this.state.Email}
                    onChange={this.onChange}
                    readOnly={true}
                  />
                </a>
                <br />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="8">
                <Row>
                  <Col sm="1"></Col>
                  <Col sm="2">
                    <Label for="Student">President</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="Advisor">Advisor</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="RiskMgt">Risk Manager</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="FinancialManager">Financial Manager</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="RosterManager">Roster Manager</Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Name</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentContact"
                      id="StudentContact"
                      value={this.state.StudentContact}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorName"
                      id="AdvisorName"
                      value={this.state.AdvisorName}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtName"
                      id="RiskMgtName"
                      value={this.state.RiskMgtName}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerName"
                      id="FinancialManagerName"
                      value={
                        this.state.FinancialManagerName
                          ? this.state.FinancialManagerName
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerName"
                      id="RosterManagerName"
                      value={
                        this.state.RosterManagerName
                          ? this.state.RosterManagerName
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Email</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentEmail"
                      id="StudentEmail"
                      value={this.state.StudentEmail}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorEmail"
                      id="AdvisorEmail"
                      value={this.state.AdvisorEmail}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtEmail"
                      id="RiskMgtEmail"
                      value={this.state.RiskMgtEmail}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerEmail"
                      id="FinancialManagerEmail"
                      value={
                        this.state.FinancialManagerEmail
                          ? this.state.FinancialManagerEmail
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerEmail"
                      id="RosterManagerEmail"
                      value={
                        this.state.RosterManagerEmail
                          ? this.state.RosterManagerEmail
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Phone</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentPhone"
                      id="StudentPhone"
                      value={this.state.StudentPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorPhone"
                      id="AdvisorPhone"
                      value={this.state.AdvisorPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtPhone"
                      id="RiskMgtPhone"
                      value={this.state.RiskMgtPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerPhone"
                      id="FinancialManagerPhone"
                      value={
                        this.state.FinancialManagerPhone
                          ? this.state.FinancialManagerPhone
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerPhone"
                      id="RosterManagerPhone"
                      value={
                        this.state.RosterManagerPhone
                          ? this.state.RosterManagerPhone
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="6">
                <Row>
                  <Col sm="3">Standing</Col>
                  <Col sm="3">
                    <p>
                      {this.state.Standing === "Good" ? (
                        <b>
                          <font color="green"> {this.state.Standing}</font>
                        </b>
                      ) : (
                        <b>
                          <font color="red"> {this.state.Standing}</font>
                        </b>
                      )}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Kirk Contract</Col>
                  <Col sm="3">
                    <p>
                      {this.state.KirkContract ? (
                        <b>
                          <font color="green"> True</font>
                        </b>
                      ) : (
                        <b>
                          <font color="red"> False</font>
                        </b>
                      )}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Constitution Date</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Constitution"
                      id="Constitution"
                      value={this.state.Constitution}
                      onChange={this.onChange}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Charter</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Charter"
                      id="Charter"
                      value={this.state.Charter}
                      onChange={this.onChange}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Size</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Size"
                      id="Size"
                      value={this.state.Size}
                      onChange={this.onChange}
                      readOnly
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
              <Col sm="12">{this.createRenewalBlock()}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="5">
            <Row>
              <Col sm="12">{this.createInfoBlock()}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="6">
            <Row>
              <Col sm="12">{this.createRosterBlock()}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="7">
            <Row>
              <Col sm="12">{this.createWorkshopBlock()}</Col>
            </Row>
          </TabPane>
		  <TabPane tabId="8">
            <Row>
              <Col sm="12">{this.createAdvisorBlock()}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="9">
            <Row>
              <Col sm="12">
                <Label for="Description">Description:</Label>
                <Input
                  type="textarea"
                  name="Description"
                  id="Description"
                  value={this.state.Description}
                  onChange={this.onChange}
                  readOnly={true}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="10">
            <Row>
              <Col sm="12">
                <Label for="CSI Notes">CSI Notes:</Label>
                <Input
                  type="textarea"
                  name="Comments"
                  id="Comments"
                  value={this.state.Comments}
                  onChange={this.onChange}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="11">
            <Row>
              <Col sm="12">{this.createRiskMgtBlock()}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="12">
            <Row>
              <Col sm="12">{this.createFinancialRiskBlock()}</Col>
            </Row>
          </TabPane>
        </TabContent>
        <Button
          color="primary"
          onClick={() => {
            this.onSave(this.state.Comments, this.state.AutoID);
          }}>
          Save
        </Button>
        <Button className="ml-2" color="danger" onClick={this.props.toggle}>
          Close
        </Button>
      </div>
    );
  }
}

export default OrgDetails;
